import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";

// Define the state type for this fetch workflow
export interface OpenOrdersState  {
    isLoading: boolean,
    data: any,
    error: string | null,
}

const initialOpenOrderState: OpenOrdersState = {
    isLoading: false,
    data: null,
    error: null
};

// Create Immer reducer
const openOrdersReducer = createTypedReducerWithImmer(initialOpenOrderState, {
    // Start loading
    "OpenOrders/IsLoading": (draft, action: { isLoading: boolean }) => {
        draft.isLoading = action.isLoading;
        if (action.isLoading) {
            draft.error = null; // Optionally reset error if reloading
        }
    },

    // Populate result on success
    "OpenOrders/PopulateResult": (draft, action: { data: any }) => {
        draft.data = action.data;
        draft.isLoading = false;
        draft.error = null;
    },

    // Handle error
    "OpenOrders/FetchError": (draft, action: { error: string }) => {
        draft.error = action.error;
        draft.isLoading = false;
    },

    // Reset all state (optional)
    "OpenOrders/Reset": draft => {
        draft.isLoading = false;
        draft.data = null;
        draft.error = null;
    }
});

// Register reducer in the root
(reducers as any).openOrders = openOrdersReducer;

// Define type for action usage
type OpenOrderReducers = {
    openOrders: typeof openOrdersReducer;
};

export type OpenOrdersActions = Parameters<OpenOrderReducers[keyof OpenOrderReducers]>[1] | AnyAction;
